// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file general/work_function.proto (package protos.general, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file general/work_function.proto.
 */
export const file_general_work_function: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from enum protos.general.WorkFunction
 */
export enum WorkFunction {
  /**
   * @generated from enum value: WORK_FUNCTION_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: WORK_FUNCTION_ANIMAL_WRANGLER = 1;
   */
  ANIMAL_WRANGLER = 1,

  /**
   * @generated from enum value: WORK_FUNCTION_DIRECTOR_OF_PHOTOGRAPHY = 2;
   */
  DIRECTOR_OF_PHOTOGRAPHY = 2,

  /**
   * @generated from enum value: WORK_FUNCTION_CAMERA_OPERATOR = 3;
   */
  CAMERA_OPERATOR = 3,

  /**
   * @generated from enum value: WORK_FUNCTION_STEADICAM_OPERATOR = 4;
   */
  STEADICAM_OPERATOR = 4,

  /**
   * @generated from enum value: WORK_FUNCTION_FIRST_ASSIST_CAMERA = 5;
   */
  FIRST_ASSIST_CAMERA = 5,

  /**
   * @generated from enum value: WORK_FUNCTION_SECOND_ASSIST_CAMERA = 6;
   */
  SECOND_ASSIST_CAMERA = 6,

  /**
   * @generated from enum value: WORK_FUNCTION_STILL_PHOTOGRAPHER = 7;
   */
  STILL_PHOTOGRAPHER = 7,

  /**
   * @generated from enum value: WORK_FUNCTION_PHOTOGRAPHER = 8;
   */
  PHOTOGRAPHER = 8,

  /**
   * @generated from enum value: WORK_FUNCTION_BTS_CAMERAPERSON = 9;
   */
  BTS_CAMERAPERSON = 9,

  /**
   * @generated from enum value: WORK_FUNCTION_VIDEO_ASSIST_OPERATOR = 10;
   */
  VIDEO_ASSIST_OPERATOR = 10,

  /**
   * @generated from enum value: WORK_FUNCTION_DIGITAL_IMAGING_TECHNICIAN = 11;
   */
  DIGITAL_IMAGING_TECHNICIAN = 11,

  /**
   * @generated from enum value: WORK_FUNCTION_DATA_WRANGLER = 12;
   */
  DATA_WRANGLER = 12,

  /**
   * @generated from enum value: WORK_FUNCTION_UNDERWATER_CAMERA_OPERATOR = 13;
   */
  UNDERWATER_CAMERA_OPERATOR = 13,

  /**
   * @generated from enum value: WORK_FUNCTION_REMOTE_HEAD_TECHNICIAN = 14;
   */
  REMOTE_HEAD_TECHNICIAN = 14,

  /**
   * @generated from enum value: WORK_FUNCTION_DRONE_OPERATOR = 15;
   */
  DRONE_OPERATOR = 15,

  /**
   * @generated from enum value: WORK_FUNCTION_UAV_OPERATOR = 16;
   */
  UAV_OPERATOR = 16,

  /**
   * @generated from enum value: WORK_FUNCTION_VIDEOGRAPHER = 17;
   */
  VIDEOGRAPHER = 17,

  /**
   * @generated from enum value: WORK_FUNCTION_COSTUME_DESIGNER = 18;
   */
  COSTUME_DESIGNER = 18,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_COSTUME_DESIGNER = 19;
   */
  ASSIST_COSTUME_DESIGNER = 19,

  /**
   * @generated from enum value: WORK_FUNCTION_COSTUME_COORDINATOR = 20;
   */
  COSTUME_COORDINATOR = 20,

  /**
   * @generated from enum value: WORK_FUNCTION_COSTUMES_SUPERVISOR = 21;
   */
  COSTUMES_SUPERVISOR = 21,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_WARDROBE_MISTRESS = 22;
   */
  KEY_WARDROBE_MISTRESS = 22,

  /**
   * @generated from enum value: WORK_FUNCTION_WARDROBE_MISTRESS = 23;
   */
  WARDROBE_MISTRESS = 23,

  /**
   * @generated from enum value: WORK_FUNCTION_COSTUMES_BUYER = 24;
   */
  COSTUMES_BUYER = 24,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_SPECIALIZED_WARDROBE_TECHNICIAN = 25;
   */
  KEY_SPECIALIZED_WARDROBE_TECHNICIAN = 25,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_WARDROBE_MISTRESS = 26;
   */
  ASSIST_WARDROBE_MISTRESS = 26,

  /**
   * @generated from enum value: WORK_FUNCTION_SPECIALIZED_WARDROBE_TECHNICIAN = 27;
   */
  SPECIALIZED_WARDROBE_TECHNICIAN = 27,

  /**
   * @generated from enum value: WORK_FUNCTION_WARDROBE_TECHNICIAN = 28;
   */
  WARDROBE_TECHNICIAN = 28,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_DRESSER = 29;
   */
  KEY_DRESSER = 29,

  /**
   * @generated from enum value: WORK_FUNCTION_DRESSER = 30;
   */
  DRESSER = 30,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_DRESSER = 31;
   */
  ASSIST_DRESSER = 31,

  /**
   * @generated from enum value: WORK_FUNCTION_WARDROBE_STYLIST = 32;
   */
  WARDROBE_STYLIST = 32,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_CRAFT_PERSON = 33;
   */
  ASSIST_CRAFT_PERSON = 33,

  /**
   * @generated from enum value: WORK_FUNCTION_CRAFT_PERSON = 34;
   */
  CRAFT_PERSON = 34,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_KEY_CRAFT = 35;
   */
  ASSIST_KEY_CRAFT = 35,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_CRAFT = 36;
   */
  KEY_CRAFT = 36,

  /**
   * @generated from enum value: WORK_FUNCTION_ART_DIRECTOR = 37;
   */
  ART_DIRECTOR = 37,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_ART_DIRECTOR = 38;
   */
  ASSIST_ART_DIRECTOR = 38,

  /**
   * @generated from enum value: WORK_FUNCTION_GRAPHIC_ARTIST = 39;
   */
  GRAPHIC_ARTIST = 39,

  /**
   * @generated from enum value: WORK_FUNCTION_PROPERTY_MANAGER = 40;
   */
  PROPERTY_MANAGER = 40,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_SET_DECORATOR = 41;
   */
  KEY_SET_DECORATOR = 41,

  /**
   * @generated from enum value: WORK_FUNCTION_SET_DRESSER = 42;
   */
  SET_DRESSER = 42,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_SET_DECORATOR = 43;
   */
  ASSIST_SET_DECORATOR = 43,

  /**
   * @generated from enum value: WORK_FUNCTION_ART_DEPARTMENT_ASSIST = 44;
   */
  ART_DEPARTMENT_ASSIST = 44,

  /**
   * @generated from enum value: WORK_FUNCTION_VEHICLE_COORDINATOR = 45;
   */
  VEHICLE_COORDINATOR = 45,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_VEHICLE_COORDINATOR = 46;
   */
  ASSIST_VEHICLE_COORDINATOR = 46,

  /**
   * @generated from enum value: WORK_FUNCTION_ACTING_COACH = 47;
   */
  ACTING_COACH = 47,

  /**
   * @generated from enum value: WORK_FUNCTION_ART_DEPARTMENT_COORDINATOR = 48;
   */
  ART_DEPARTMENT_COORDINATOR = 48,

  /**
   * @generated from enum value: WORK_FUNCTION_DRAFTSPERSON = 49;
   */
  DRAFTSPERSON = 49,

  /**
   * @generated from enum value: WORK_FUNCTION_PRODUCTION_DESIGNER = 50;
   */
  PRODUCTION_DESIGNER = 50,

  /**
   * @generated from enum value: WORK_FUNCTION_SET_DESIGNER = 51;
   */
  SET_DESIGNER = 51,

  /**
   * @generated from enum value: WORK_FUNCTION_COMMERCIAL_ART_DIRECTOR = 52;
   */
  COMMERCIAL_ART_DIRECTOR = 52,

  /**
   * @generated from enum value: WORK_FUNCTION_STORYBOARD_ARTIST = 53;
   */
  STORYBOARD_ARTIST = 53,

  /**
   * @generated from enum value: WORK_FUNCTION_CONCEPT_ARTIST_ILLUSTRATOR = 54;
   */
  CONCEPT_ARTIST_ILLUSTRATOR = 54,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_ART_DEPARTMENT_COORDINATOR = 55;
   */
  ASSIST_ART_DEPARTMENT_COORDINATOR = 55,

  /**
   * @generated from enum value: WORK_FUNCTION_CONSTRUCTION_COORDINATOR = 56;
   */
  CONSTRUCTION_COORDINATOR = 56,

  /**
   * @generated from enum value: WORK_FUNCTION_CONSTRUCTION_SUPERVISOR = 57;
   */
  CONSTRUCTION_SUPERVISOR = 57,

  /**
   * @generated from enum value: WORK_FUNCTION_HEAD_CARPENTER = 58;
   */
  HEAD_CARPENTER = 58,

  /**
   * @generated from enum value: WORK_FUNCTION_CARPENTER = 59;
   */
  CARPENTER = 59,

  /**
   * @generated from enum value: WORK_FUNCTION_WELDER = 60;
   */
  WELDER = 60,

  /**
   * @generated from enum value: WORK_FUNCTION_PAINTER = 61;
   */
  PAINTER = 61,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_PAINTER = 62;
   */
  ASSIST_PAINTER = 62,

  /**
   * @generated from enum value: WORK_FUNCTION_SCENIC_PAINTER = 63;
   */
  SCENIC_PAINTER = 63,

  /**
   * @generated from enum value: WORK_FUNCTION_PROP_MASTER = 64;
   */
  PROP_MASTER = 64,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_PROPS = 65;
   */
  KEY_PROPS = 65,

  /**
   * @generated from enum value: WORK_FUNCTION_PROPS = 66;
   */
  PROPS = 66,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_PROPS = 67;
   */
  ASSIST_PROPS = 67,

  /**
   * @generated from enum value: WORK_FUNCTION_PROP_MAKER = 68;
   */
  PROP_MAKER = 68,

  /**
   * @generated from enum value: WORK_FUNCTION_PROPS_DESIGNER = 69;
   */
  PROPS_DESIGNER = 69,

  /**
   * @generated from enum value: WORK_FUNCTION_SCULPTOR_MOULDER = 70;
   */
  SCULPTOR_MOULDER = 70,

  /**
   * @generated from enum value: WORK_FUNCTION_PLASTERER = 71;
   */
  PLASTERER = 71,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_PLASTERER = 72;
   */
  ASSIST_PLASTERER = 72,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_GREENSPERSON = 73;
   */
  KEY_GREENSPERSON = 73,

  /**
   * @generated from enum value: WORK_FUNCTION_GREENSPERSON = 74;
   */
  GREENSPERSON = 74,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_GREENSPERSON = 75;
   */
  ASSIST_GREENSPERSON = 75,

  /**
   * @generated from enum value: WORK_FUNCTION_FIRST_ASSIST_DIRECTOR = 76;
   */
  FIRST_ASSIST_DIRECTOR = 76,

  /**
   * @generated from enum value: WORK_FUNCTION_SECOND_ASSIST_DIRECTOR = 77;
   */
  SECOND_ASSIST_DIRECTOR = 77,

  /**
   * @generated from enum value: WORK_FUNCTION_THIRD_ASSIST_DIRECTOR = 78;
   */
  THIRD_ASSIST_DIRECTOR = 78,

  /**
   * @generated from enum value: WORK_FUNCTION_DIRECTOR = 79;
   */
  DIRECTOR = 79,

  /**
   * @generated from enum value: WORK_FUNCTION_SOLE_ANIMATION_DIRECTOR = 80;
   */
  SOLE_ANIMATION_DIRECTOR = 80,

  /**
   * @generated from enum value: WORK_FUNCTION_DOCUMENTARY_DIRECTOR = 81;
   */
  DOCUMENTARY_DIRECTOR = 81,

  /**
   * @generated from enum value: WORK_FUNCTION_SCRIPT_SUPERVISOR = 82;
   */
  SCRIPT_SUPERVISOR = 82,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_SCRIPT_SUPERVISOR = 83;
   */
  ASSIST_SCRIPT_SUPERVISOR = 83,

  /**
   * @generated from enum value: WORK_FUNCTION_EDITOR = 84;
   */
  EDITOR = 84,

  /**
   * @generated from enum value: WORK_FUNCTION_ONLINE_EDITOR = 85;
   */
  ONLINE_EDITOR = 85,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_EDITOR = 86;
   */
  ASSIST_EDITOR = 86,

  /**
   * @generated from enum value: WORK_FUNCTION_SOUND_EDITOR = 87;
   */
  SOUND_EDITOR = 87,

  /**
   * @generated from enum value: WORK_FUNCTION_CASTING_DIRECTOR = 88;
   */
  CASTING_DIRECTOR = 88,

  /**
   * @generated from enum value: WORK_FUNCTION_COLORIST = 89;
   */
  COLORIST = 89,

  /**
   * @generated from enum value: WORK_FUNCTION_POST_PRODUCTION_SUPERVISOR = 90;
   */
  POST_PRODUCTION_SUPERVISOR = 90,

  /**
   * @generated from enum value: WORK_FUNCTION_POST_PRODUCTION_COORDINATOR = 91;
   */
  POST_PRODUCTION_COORDINATOR = 91,

  /**
   * @generated from enum value: WORK_FUNCTION_POST_PRODUCTION_TECHNICIAN = 92;
   */
  POST_PRODUCTION_TECHNICIAN = 92,

  /**
   * @generated from enum value: WORK_FUNCTION_DOCUMENTARY_EDITOR = 93;
   */
  DOCUMENTARY_EDITOR = 93,

  /**
   * @generated from enum value: WORK_FUNCTION_TECHNICAL_COORDINATOR = 94;
   */
  TECHNICAL_COORDINATOR = 94,

  /**
   * @generated from enum value: WORK_FUNCTION_FIRST_ASSIST_SOUND_EDITOR = 95;
   */
  FIRST_ASSIST_SOUND_EDITOR = 95,

  /**
   * @generated from enum value: WORK_FUNCTION_SECOND_ASSIST_SOUND_EDITOR = 96;
   */
  SECOND_ASSIST_SOUND_EDITOR = 96,

  /**
   * @generated from enum value: WORK_FUNCTION_MUSIC_EDITOR = 97;
   */
  MUSIC_EDITOR = 97,

  /**
   * @generated from enum value: WORK_FUNCTION_SUPERVISING_SOUND_EDITOR = 98;
   */
  SUPERVISING_SOUND_EDITOR = 98,

  /**
   * @generated from enum value: WORK_FUNCTION_VFX_PRODUCER = 99;
   */
  VFX_PRODUCER = 99,

  /**
   * @generated from enum value: WORK_FUNCTION_VFX_SUPERVISOR = 100;
   */
  VFX_SUPERVISOR = 100,

  /**
   * @generated from enum value: WORK_FUNCTION_VFX_TECHNICIAN = 101;
   */
  VFX_TECHNICIAN = 101,

  /**
   * @generated from enum value: WORK_FUNCTION_VFX_COORDINATOR = 102;
   */
  VFX_COORDINATOR = 102,

  /**
   * @generated from enum value: WORK_FUNCTION_VFX_ARTIST = 103;
   */
  VFX_ARTIST = 103,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_GRIP = 104;
   */
  KEY_GRIP = 104,

  /**
   * @generated from enum value: WORK_FUNCTION_GRIP_BEST_BOY_BEST_GIRL = 105;
   */
  GRIP_BEST_BOY_BEST_GIRL = 105,

  /**
   * @generated from enum value: WORK_FUNCTION_GRIP = 106;
   */
  GRIP = 106,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_RIGGING_GRIP = 107;
   */
  KEY_RIGGING_GRIP = 107,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_RIGGING_GRIP_BEST_BOY_BEST_GIRL = 108;
   */
  KEY_RIGGING_GRIP_BEST_BOY_BEST_GIRL = 108,

  /**
   * @generated from enum value: WORK_FUNCTION_RIGGING_GRIP = 109;
   */
  RIGGING_GRIP = 109,

  /**
   * @generated from enum value: WORK_FUNCTION_DOLLY_GRIP_OPERATOR = 110;
   */
  DOLLY_GRIP_OPERATOR = 110,

  /**
   * @generated from enum value: WORK_FUNCTION_CAMERA_CRANE_OPERATOR = 111;
   */
  CAMERA_CRANE_OPERATOR = 111,

  /**
   * @generated from enum value: WORK_FUNCTION_GAFFER = 112;
   */
  GAFFER = 112,

  /**
   * @generated from enum value: WORK_FUNCTION_ELECTRO_BEST_BOY_BEST_GIRL = 113;
   */
  ELECTRO_BEST_BOY_BEST_GIRL = 113,

  /**
   * @generated from enum value: WORK_FUNCTION_LIGHTING_TECHNICIAN = 114;
   */
  LIGHTING_TECHNICIAN = 114,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_RIGGING_GAFFER = 115;
   */
  KEY_RIGGING_GAFFER = 115,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_RIGGING_GAFFER_BEST_BOY_BEST_GIRL = 116;
   */
  KEY_RIGGING_GAFFER_BEST_BOY_BEST_GIRL = 116,

  /**
   * @generated from enum value: WORK_FUNCTION_RIGGING_LIGHTING_TECHNICIAN = 117;
   */
  RIGGING_LIGHTING_TECHNICIAN = 117,

  /**
   * @generated from enum value: WORK_FUNCTION_LIGHTING_CONTROL_CONSOLE_OPERATOR = 118;
   */
  LIGHTING_CONTROL_CONSOLE_OPERATOR = 118,

  /**
   * @generated from enum value: WORK_FUNCTION_GENERATOR_OPERATOR = 119;
   */
  GENERATOR_OPERATOR = 119,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_HAIRDRESSER = 120;
   */
  ASSIST_HAIRDRESSER = 120,

  /**
   * @generated from enum value: WORK_FUNCTION_HAIRDRESSER = 121;
   */
  HAIRDRESSER = 121,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_HAIRDRESSER = 122;
   */
  KEY_HAIRDRESSER = 122,

  /**
   * @generated from enum value: WORK_FUNCTION_MAKE_UP_ARTIST = 123;
   */
  MAKE_UP_ARTIST = 123,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_MAKE_UP_ARTIST = 124;
   */
  ASSIST_MAKE_UP_ARTIST = 124,

  /**
   * @generated from enum value: WORK_FUNCTION_SFX_MAKE_UP_ARTIST = 125;
   */
  SFX_MAKE_UP_ARTIST = 125,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_SFX_MAKE_UP_ARTIST = 126;
   */
  ASSIST_SFX_MAKE_UP_ARTIST = 126,

  /**
   * @generated from enum value: WORK_FUNCTION_FIRST_AID_ATTENDANT = 127;
   */
  FIRST_AID_ATTENDANT = 127,

  /**
   * @generated from enum value: WORK_FUNCTION_LOCATION_MANAGER = 128;
   */
  LOCATION_MANAGER = 128,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_LOCATION_MANAGER = 129;
   */
  ASSIST_LOCATION_MANAGER = 129,

  /**
   * @generated from enum value: WORK_FUNCTION_LOCATION_SCOUT = 130;
   */
  LOCATION_SCOUT = 130,

  /**
   * @generated from enum value: WORK_FUNCTION_PRODUCTION_COORDINATOR = 131;
   */
  PRODUCTION_COORDINATOR = 131,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_PRODUCTION_COORDINATOR = 132;
   */
  ASSIST_PRODUCTION_COORDINATOR = 132,

  /**
   * @generated from enum value: WORK_FUNCTION_PRODUCTION_SECRETARY = 133;
   */
  PRODUCTION_SECRETARY = 133,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_PRODUCTION_MANAGER = 134;
   */
  ASSIST_PRODUCTION_MANAGER = 134,

  /**
   * @generated from enum value: WORK_FUNCTION_PRODUCTION_MANAGER = 135;
   */
  PRODUCTION_MANAGER = 135,

  /**
   * @generated from enum value: WORK_FUNCTION_UNIT_MANAGER = 136;
   */
  UNIT_MANAGER = 136,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_UNIT_MANAGER = 137;
   */
  ASSIST_UNIT_MANAGER = 137,

  /**
   * @generated from enum value: WORK_FUNCTION_PRODUCTION_ASSIST = 138;
   */
  PRODUCTION_ASSIST = 138,

  /**
   * @generated from enum value: WORK_FUNCTION_TRANSPORT_COORDINATOR = 139;
   */
  TRANSPORT_COORDINATOR = 139,

  /**
   * @generated from enum value: WORK_FUNCTION_TRANSPORT_CAPTAIN = 140;
   */
  TRANSPORT_CAPTAIN = 140,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_TRANSPORT_COORDINATOR = 141;
   */
  ASSIST_TRANSPORT_COORDINATOR = 141,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_TRANSPORT_CAPTAIN = 142;
   */
  ASSIST_TRANSPORT_CAPTAIN = 142,

  /**
   * @generated from enum value: WORK_FUNCTION_SPECIALIZED_DRIVER = 143;
   */
  SPECIALIZED_DRIVER = 143,

  /**
   * @generated from enum value: WORK_FUNCTION_DRIVER = 144;
   */
  DRIVER = 144,

  /**
   * @generated from enum value: WORK_FUNCTION_RUNNER_DRIVER = 145;
   */
  RUNNER_DRIVER = 145,

  /**
   * @generated from enum value: WORK_FUNCTION_BASE_CAMP_OPERATOR = 146;
   */
  BASE_CAMP_OPERATOR = 146,

  /**
   * @generated from enum value: WORK_FUNCTION_PRODUCER = 147;
   */
  PRODUCER = 147,

  /**
   * @generated from enum value: WORK_FUNCTION_LINE_PRODUCER = 148;
   */
  LINE_PRODUCER = 148,

  /**
   * @generated from enum value: WORK_FUNCTION_EXECUTIVE_PRODUCER = 149;
   */
  EXECUTIVE_PRODUCER = 149,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSOCIATE_PRODUCER = 150;
   */
  ASSOCIATE_PRODUCER = 150,

  /**
   * @generated from enum value: WORK_FUNCTION_SOUND_RECORDIST = 151;
   */
  SOUND_RECORDIST = 151,

  /**
   * @generated from enum value: WORK_FUNCTION_RECORDIST_ASSIST = 152;
   */
  RECORDIST_ASSIST = 152,

  /**
   * @generated from enum value: WORK_FUNCTION_SOUND_MIXER = 153;
   */
  SOUND_MIXER = 153,

  /**
   * @generated from enum value: WORK_FUNCTION_BOOM_OPERATOR = 154;
   */
  BOOM_OPERATOR = 154,

  /**
   * @generated from enum value: WORK_FUNCTION_ADR_SUPERVISOR = 155;
   */
  ADR_SUPERVISOR = 155,

  /**
   * @generated from enum value: WORK_FUNCTION_SFX_COORDINATOR = 156;
   */
  SFX_COORDINATOR = 156,

  /**
   * @generated from enum value: WORK_FUNCTION_SFX_KEY_TECHNICIAN = 157;
   */
  SFX_KEY_TECHNICIAN = 157,

  /**
   * @generated from enum value: WORK_FUNCTION_SFX_TECHNICIAN = 158;
   */
  SFX_TECHNICIAN = 158,

  /**
   * @generated from enum value: WORK_FUNCTION_SFX_ASSIST_TECH = 159;
   */
  SFX_ASSIST_TECH = 159,

  /**
   * @generated from enum value: WORK_FUNCTION_ELECTRONIC_CAMERAPERSON = 160;
   */
  ELECTRONIC_CAMERAPERSON = 160,

  /**
   * @generated from enum value: WORK_FUNCTION_CAMERA_ASSIST = 161;
   */
  CAMERA_ASSIST = 161,

  /**
   * @generated from enum value: WORK_FUNCTION_TECHNICAL_DIRECTOR = 162;
   */
  TECHNICAL_DIRECTOR = 162,

  /**
   * @generated from enum value: WORK_FUNCTION_STAGEHAND = 163;
   */
  STAGEHAND = 163,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_MOBILE_SET_UP_TECH = 164;
   */
  KEY_MOBILE_SET_UP_TECH = 164,

  /**
   * @generated from enum value: WORK_FUNCTION_MOBILE_SET_UP_TECH = 165;
   */
  MOBILE_SET_UP_TECH = 165,

  /**
   * @generated from enum value: WORK_FUNCTION_CCU_OPERATOR = 166;
   */
  CCU_OPERATOR = 166,

  /**
   * @generated from enum value: WORK_FUNCTION_VIDEO_TAPE_OPERATOR = 167;
   */
  VIDEO_TAPE_OPERATOR = 167,

  /**
   * @generated from enum value: WORK_FUNCTION_TELEPROMPTER_OPERATOR = 168;
   */
  TELEPROMPTER_OPERATOR = 168,

  /**
   * @generated from enum value: WORK_FUNCTION_SWITCHER = 169;
   */
  SWITCHER = 169,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_DIRECTOR_TV = 170;
   */
  ASSIST_DIRECTOR_TV = 170,

  /**
   * @generated from enum value: WORK_FUNCTION_STAGE_MANAGER = 171;
   */
  STAGE_MANAGER = 171,

  /**
   * @generated from enum value: WORK_FUNCTION_SOUND_ENGINEER = 172;
   */
  SOUND_ENGINEER = 172,

  /**
   * @generated from enum value: WORK_FUNCTION_FOLLOW_SPOT_OPERATOR = 173;
   */
  FOLLOW_SPOT_OPERATOR = 173,

  /**
   * @generated from enum value: WORK_FUNCTION_ARMOURER = 174;
   */
  ARMOURER = 174,

  /**
   * @generated from enum value: WORK_FUNCTION_FIRST_ASSIST_ACCOUNTING = 175;
   */
  FIRST_ASSIST_ACCOUNTING = 175,

  /**
   * @generated from enum value: WORK_FUNCTION_FIRST_ASSIST_ACCOUNTANT_GENERAL = 176;
   */
  FIRST_ASSIST_ACCOUNTANT_GENERAL = 176,

  /**
   * @generated from enum value: WORK_FUNCTION_FIRST_ASSIST_ACCOUNTANT_PAYROLL = 177;
   */
  FIRST_ASSIST_ACCOUNTANT_PAYROLL = 177,

  /**
   * @generated from enum value: WORK_FUNCTION_SECOND_ASSIST_ACCOUNTANT = 178;
   */
  SECOND_ASSIST_ACCOUNTANT = 178,

  /**
   * @generated from enum value: WORK_FUNCTION_THIRD_ASSIST_ACCOUNTANT = 179;
   */
  THIRD_ASSIST_ACCOUNTANT = 179,

  /**
   * @generated from enum value: WORK_FUNCTION_PRODUCTION_ACCOUNTANT = 180;
   */
  PRODUCTION_ACCOUNTANT = 180,

  /**
   * @generated from enum value: WORK_FUNCTION_POST_PRODUCTION_ACCOUNTANT = 181;
   */
  POST_PRODUCTION_ACCOUNTANT = 181,

  /**
   * @generated from enum value: WORK_FUNCTION_ACCOUNTING_CLERK = 182;
   */
  ACCOUNTING_CLERK = 182,

  /**
   * @generated from enum value: WORK_FUNCTION_TRAINEE_ACCOUNTANT = 183;
   */
  TRAINEE_ACCOUNTANT = 183,

  /**
   * @generated from enum value: WORK_FUNCTION_PRODUCTION_COMPANY = 184;
   */
  PRODUCTION_COMPANY = 184,

  /**
   * @generated from enum value: WORK_FUNCTION_CREATIVE_AGENCY = 185;
   */
  CREATIVE_AGENCY = 185,

  /**
   * @generated from enum value: WORK_FUNCTION_POST_PRODUCTION_HOUSE = 186;
   */
  POST_PRODUCTION_HOUSE = 186,

  /**
   * @generated from enum value: WORK_FUNCTION_AUDIO_POST_PRODUCTION_HOUSE = 187;
   */
  AUDIO_POST_PRODUCTION_HOUSE = 187,

  /**
   * @generated from enum value: WORK_FUNCTION_RENTAL_AND_POST_PRODUCTION_COMPANY = 188;
   */
  RENTAL_AND_POST_PRODUCTION_COMPANY = 188,

  /**
   * @generated from enum value: WORK_FUNCTION_CAMERA_RENTAL_HOUSE = 189;
   */
  CAMERA_RENTAL_HOUSE = 189,

  /**
   * @generated from enum value: WORK_FUNCTION_CINEMA_STUDIO_RENTAL = 190;
   */
  CINEMA_STUDIO_RENTAL = 190,

  /**
   * @generated from enum value: WORK_FUNCTION_MUSIC_STUDIO_RENTAL = 191;
   */
  MUSIC_STUDIO_RENTAL = 191,

  /**
   * @generated from enum value: WORK_FUNCTION_FILM_DISTRIBUTION_STUDIO = 192;
   */
  FILM_DISTRIBUTION_STUDIO = 192,

  /**
   * @generated from enum value: WORK_FUNCTION_VFX_STUDIO = 193;
   */
  VFX_STUDIO = 193,

  /**
   * @generated from enum value: WORK_FUNCTION_SOUND_STUDIO = 194;
   */
  SOUND_STUDIO = 194,

  /**
   * @generated from enum value: WORK_FUNCTION_CASTING_AGENCY = 195;
   */
  CASTING_AGENCY = 195,

  /**
   * @generated from enum value: WORK_FUNCTION_SFX_COMPANY = 196;
   */
  SFX_COMPANY = 196,

  /**
   * @generated from enum value: WORK_FUNCTION_PROPS_RENTAL_HOUSE = 197;
   */
  PROPS_RENTAL_HOUSE = 197,

  /**
   * @generated from enum value: WORK_FUNCTION_TALENT_AGENCY = 198;
   */
  TALENT_AGENCY = 198,

  /**
   * @generated from enum value: WORK_FUNCTION_PUBLIC_RELATIONS_AGENCY = 199;
   */
  PUBLIC_RELATIONS_AGENCY = 199,

  /**
   * @generated from enum value: WORK_FUNCTION_ANIMATION_STUDIO = 200;
   */
  ANIMATION_STUDIO = 200,

  /**
   * @generated from enum value: WORK_FUNCTION_CATERING_SERVICES = 201;
   */
  CATERING_SERVICES = 201,

  /**
   * @generated from enum value: WORK_FUNCTION_STREAMING_PLATFORM = 202;
   */
  STREAMING_PLATFORM = 202,

  /**
   * @generated from enum value: WORK_FUNCTION_FILM_COMMISSION = 203;
   */
  FILM_COMMISSION = 203,

  /**
   * @generated from enum value: WORK_FUNCTION_FILM_SCHOOL = 204;
   */
  FILM_SCHOOL = 204,

  /**
   * @generated from enum value: WORK_FUNCTION_FILM_FESTIVAL = 205;
   */
  FILM_FESTIVAL = 205,

  /**
   * @generated from enum value: WORK_FUNCTION_MUSIC_COMPOSER = 206;
   */
  MUSIC_COMPOSER = 206,

  /**
   * @generated from enum value: WORK_FUNCTION_CONDUCTOR = 207;
   */
  CONDUCTOR = 207,

  /**
   * @generated from enum value: WORK_FUNCTION_SINGER = 208;
   */
  SINGER = 208,

  /**
   * @generated from enum value: WORK_FUNCTION_PIANIST = 209;
   */
  PIANIST = 209,

  /**
   * @generated from enum value: WORK_FUNCTION_VIOLINIST = 210;
   */
  VIOLINIST = 210,

  /**
   * @generated from enum value: WORK_FUNCTION_CELLIST = 211;
   */
  CELLIST = 211,

  /**
   * @generated from enum value: WORK_FUNCTION_GUITARIST = 212;
   */
  GUITARIST = 212,

  /**
   * @generated from enum value: WORK_FUNCTION_BASSIST = 213;
   */
  BASSIST = 213,

  /**
   * @generated from enum value: WORK_FUNCTION_DRUMMER = 214;
   */
  DRUMMER = 214,

  /**
   * @generated from enum value: WORK_FUNCTION_FLUTIST = 215;
   */
  FLUTIST = 215,

  /**
   * @generated from enum value: WORK_FUNCTION_CLARINETIST = 216;
   */
  CLARINETIST = 216,

  /**
   * @generated from enum value: WORK_FUNCTION_SAXOPHONIST = 217;
   */
  SAXOPHONIST = 217,

  /**
   * @generated from enum value: WORK_FUNCTION_TRUMPETER = 218;
   */
  TRUMPETER = 218,

  /**
   * @generated from enum value: WORK_FUNCTION_TROMBONIST = 219;
   */
  TROMBONIST = 219,

  /**
   * @generated from enum value: WORK_FUNCTION_HARPIST = 220;
   */
  HARPIST = 220,

  /**
   * @generated from enum value: WORK_FUNCTION_PERCUSSIONIST = 221;
   */
  PERCUSSIONIST = 221,

  /**
   * @generated from enum value: WORK_FUNCTION_ACCORDIONIST = 222;
   */
  ACCORDIONIST = 222,

  /**
   * @generated from enum value: WORK_FUNCTION_ORGANIST = 223;
   */
  ORGANIST = 223,

  /**
   * @generated from enum value: WORK_FUNCTION_OBOIST = 224;
   */
  OBOIST = 224,

  /**
   * @generated from enum value: WORK_FUNCTION_BASSOONIST = 225;
   */
  BASSOONIST = 225,

  /**
   * @generated from enum value: WORK_FUNCTION_DJ = 226;
   */
  DJ = 226,

  /**
   * @generated from enum value: WORK_FUNCTION_SONGWRITER = 227;
   */
  SONGWRITER = 227,

  /**
   * @generated from enum value: WORK_FUNCTION_MUSIC_PRODUCER = 228;
   */
  MUSIC_PRODUCER = 228,

  /**
   * @generated from enum value: WORK_FUNCTION_BAGPIPER = 229;
   */
  BAGPIPER = 229,

  /**
   * @generated from enum value: WORK_FUNCTION_BANJO_PLAYER = 230;
   */
  BANJO_PLAYER = 230,

  /**
   * @generated from enum value: WORK_FUNCTION_MANDOLIN_PLAYER = 231;
   */
  MANDOLIN_PLAYER = 231,

  /**
   * @generated from enum value: WORK_FUNCTION_HORN_PLAYER = 232;
   */
  HORN_PLAYER = 232,

  /**
   * @generated from enum value: WORK_FUNCTION_TUBA_PLAYER = 233;
   */
  TUBA_PLAYER = 233,

  /**
   * @generated from enum value: WORK_FUNCTION_UKULELE_PLAYER = 234;
   */
  UKULELE_PLAYER = 234,

  /**
   * @generated from enum value: WORK_FUNCTION_HARMONICA_PLAYER = 235;
   */
  HARMONICA_PLAYER = 235,

  /**
   * @generated from enum value: WORK_FUNCTION_DOUBLE_BASS_PLAYER = 236;
   */
  DOUBLE_BASS_PLAYER = 236,

  /**
   * @generated from enum value: WORK_FUNCTION_ELECTRIC_GUITARIST = 237;
   */
  ELECTRIC_GUITARIST = 237,

  /**
   * @generated from enum value: WORK_FUNCTION_BEATMAKER = 238;
   */
  BEATMAKER = 238,

  /**
   * @generated from enum value: WORK_FUNCTION_BACKUP_VOCALIST = 239;
   */
  BACKUP_VOCALIST = 239,

  /**
   * @generated from enum value: WORK_FUNCTION_RAPPER = 240;
   */
  RAPPER = 240,

  /**
   * @generated from enum value: WORK_FUNCTION_BEATBOXER = 241;
   */
  BEATBOXER = 241,

  /**
   * @generated from enum value: WORK_FUNCTION_FOLEY_ARTIST = 242;
   */
  FOLEY_ARTIST = 242,

  /**
   * @generated from enum value: WORK_FUNCTION_ACTOR = 243;
   */
  ACTOR = 243,

  /**
   * @generated from enum value: WORK_FUNCTION_BODY_DOUBLE = 244;
   */
  BODY_DOUBLE = 244,

  /**
   * @generated from enum value: WORK_FUNCTION_STAND_IN = 245;
   */
  STAND_IN = 245,

  /**
   * @generated from enum value: WORK_FUNCTION_BACKGROUND_ACTOR = 246;
   */
  BACKGROUND_ACTOR = 246,

  /**
   * @generated from enum value: WORK_FUNCTION_VOICE_ACTOR = 247;
   */
  VOICE_ACTOR = 247,

  /**
   * @generated from enum value: WORK_FUNCTION_NARRATOR = 248;
   */
  NARRATOR = 248,

  /**
   * @generated from enum value: WORK_FUNCTION_STUNTMAN_WOMAN = 249;
   */
  STUNTMAN_WOMAN = 249,

  /**
   * @generated from enum value: WORK_FUNCTION_STUNT_COORDINATOR = 250;
   */
  STUNT_COORDINATOR = 250,

  /**
   * @generated from enum value: WORK_FUNCTION_STUNT_DOUBLE = 251;
   */
  STUNT_DOUBLE = 251,

  /**
   * @generated from enum value: WORK_FUNCTION_MOTION_CAPTURE_ACTOR = 252;
   */
  MOTION_CAPTURE_ACTOR = 252,

  /**
   * @generated from enum value: WORK_FUNCTION_PUPPETEER = 253;
   */
  PUPPETEER = 253,

  /**
   * @generated from enum value: WORK_FUNCTION_MIME = 254;
   */
  MIME = 254,

  /**
   * @generated from enum value: WORK_FUNCTION_CLOWN = 255;
   */
  CLOWN = 255,

  /**
   * @generated from enum value: WORK_FUNCTION_DANCER_PERFORMER = 256;
   */
  DANCER_PERFORMER = 256,

  /**
   * @generated from enum value: WORK_FUNCTION_MODEL = 257;
   */
  MODEL = 257,

  /**
   * @generated from enum value: WORK_FUNCTION_TELEVISION_HOST = 258;
   */
  TELEVISION_HOST = 258,

  /**
   * @generated from enum value: WORK_FUNCTION_RADIO_HOST = 259;
   */
  RADIO_HOST = 259,

  /**
   * @generated from enum value: WORK_FUNCTION_COMEDIAN = 260;
   */
  COMEDIAN = 260,

  /**
   * @generated from enum value: WORK_FUNCTION_DRAG_PERFORMER = 261;
   */
  DRAG_PERFORMER = 261,

  /**
   * @generated from enum value: WORK_FUNCTION_CIRCUS_PERFORMER = 262;
   */
  CIRCUS_PERFORMER = 262,

  /**
   * @generated from enum value: WORK_FUNCTION_MAGICIAN = 263;
   */
  MAGICIAN = 263,

  /**
   * @generated from enum value: WORK_FUNCTION_SPORTS_COMMENTATOR = 264;
   */
  SPORTS_COMMENTATOR = 264,

  /**
   * @generated from enum value: WORK_FUNCTION_IMPERSONATOR = 265;
   */
  IMPERSONATOR = 265,

  /**
   * @generated from enum value: WORK_FUNCTION_NUDITY_COORDINATOR = 266;
   */
  NUDITY_COORDINATOR = 266,

  /**
   * @generated from enum value: WORK_FUNCTION_CHOREOGRAPHER = 267;
   */
  CHOREOGRAPHER = 267,

  /**
   * @generated from enum value: WORK_FUNCTION_SHOWRUNNER = 268;
   */
  SHOWRUNNER = 268,

  /**
   * @generated from enum value: WORK_FUNCTION_SCRIPTWRITER = 269;
   */
  SCRIPTWRITER = 269,

  /**
   * @generated from enum value: WORK_FUNCTION_SET_DECORATOR = 270;
   */
  SET_DECORATOR = 270,

  /**
   * @generated from enum value: WORK_FUNCTION_ON_SET_DECORATOR = 271;
   */
  ON_SET_DECORATOR = 271,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_ON_SET_DECORATOR = 272;
   */
  ASSIST_ON_SET_DECORATOR = 272,

  /**
   * @generated from enum value: WORK_FUNCTION_DECORATION_LEADPERSON = 273;
   */
  DECORATION_LEADPERSON = 273,

  /**
   * @generated from enum value: WORK_FUNCTION_PROPS_ON_SET = 274;
   */
  PROPS_ON_SET = 274,

  /**
   * @generated from enum value: WORK_FUNCTION_ASSIST_ON_SET_PROPS = 275;
   */
  ASSIST_ON_SET_PROPS = 275,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_PROPS_BUYER = 276;
   */
  KEY_PROPS_BUYER = 276,

  /**
   * @generated from enum value: WORK_FUNCTION_PROPS_BUYER = 277;
   */
  PROPS_BUYER = 277,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_PROP_MAKER = 278;
   */
  KEY_PROP_MAKER = 278,

  /**
   * @generated from enum value: WORK_FUNCTION_GRAPHIC_DESIGNER_SUPERVISOR = 279;
   */
  GRAPHIC_DESIGNER_SUPERVISOR = 279,

  /**
   * @generated from enum value: WORK_FUNCTION_MODEL_MAKER_SUPERVISOR = 280;
   */
  MODEL_MAKER_SUPERVISOR = 280,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_MODEL_MAKER = 281;
   */
  KEY_MODEL_MAKER = 281,

  /**
   * @generated from enum value: WORK_FUNCTION_MODEL_MAKER = 282;
   */
  MODEL_MAKER = 282,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_SPECIALIZED_DECORATION_MAKER = 283;
   */
  KEY_SPECIALIZED_DECORATION_MAKER = 283,

  /**
   * @generated from enum value: WORK_FUNCTION_SPECIALIZED_DECORATION_MAKER = 284;
   */
  SPECIALIZED_DECORATION_MAKER = 284,

  /**
   * @generated from enum value: WORK_FUNCTION_SCRIPT_EDITOR = 285;
   */
  SCRIPT_EDITOR = 285,

  /**
   * @generated from enum value: WORK_FUNCTION_SCREENWRITING_ADVISOR = 286;
   */
  SCREENWRITING_ADVISOR = 286,

  /**
   * @generated from enum value: WORK_FUNCTION_AUTHOR = 287;
   */
  AUTHOR = 287,

  /**
   * @generated from enum value: WORK_FUNCTION_RESEARCHER = 288;
   */
  RESEARCHER = 288,

  /**
   * @generated from enum value: WORK_FUNCTION_DEVELOPMENT_DESIGNER = 289;
   */
  DEVELOPMENT_DESIGNER = 289,

  /**
   * @generated from enum value: WORK_FUNCTION_CONTENT_PRODUCER = 290;
   */
  CONTENT_PRODUCER = 290,

  /**
   * @generated from enum value: WORK_FUNCTION_THREED_ARTIST = 291;
   */
  THREED_ARTIST = 291,

  /**
   * @generated from enum value: WORK_FUNCTION_CONCEPT_ARTIST_VFX = 292;
   */
  CONCEPT_ARTIST_VFX = 292,

  /**
   * @generated from enum value: WORK_FUNCTION_ANIMATOR_VFX = 293;
   */
  ANIMATOR_VFX = 293,

  /**
   * @generated from enum value: WORK_FUNCTION_ENVIRONMENT_ARTIST_VFX = 294;
   */
  ENVIRONMENT_ARTIST_VFX = 294,

  /**
   * @generated from enum value: WORK_FUNCTION_ROTO_ARTIST = 295;
   */
  ROTO_ARTIST = 295,

  /**
   * @generated from enum value: WORK_FUNCTION_COMPOSITOR_VFX = 296;
   */
  COMPOSITOR_VFX = 296,

  /**
   * @generated from enum value: WORK_FUNCTION_TWOD_ARTIST = 297;
   */
  TWOD_ARTIST = 297,

  /**
   * @generated from enum value: WORK_FUNCTION_MOTION_GRAPHICS_DESIGNER = 298;
   */
  MOTION_GRAPHICS_DESIGNER = 298,

  /**
   * @generated from enum value: WORK_FUNCTION_CAPTIONER = 299;
   */
  CAPTIONER = 299,

  /**
   * @generated from enum value: WORK_FUNCTION_LEADMAN_GRIP = 300;
   */
  LEADMAN_GRIP = 300,

  /**
   * @generated from enum value: WORK_FUNCTION_LIGHTING_LEADPERSON = 301;
   */
  LIGHTING_LEADPERSON = 301,

  /**
   * @generated from enum value: WORK_FUNCTION_HAIR_DESIGNER = 302;
   */
  HAIR_DESIGNER = 302,

  /**
   * @generated from enum value: WORK_FUNCTION_KEY_MAKE_UP_ARTIST = 303;
   */
  KEY_MAKE_UP_ARTIST = 303,

  /**
   * @generated from enum value: WORK_FUNCTION_MAKE_UP_DESIGNER = 304;
   */
  MAKE_UP_DESIGNER = 304,

  /**
   * @generated from enum value: WORK_FUNCTION_PROJECT_MANAGER = 305;
   */
  PROJECT_MANAGER = 305,

  /**
   * @generated from enum value: WORK_FUNCTION_LOGISTICS_EQUIPMENT_RENTAL = 306;
   */
  LOGISTICS_EQUIPMENT_RENTAL = 306,

  /**
   * @generated from enum value: WORK_FUNCTION_GRIP_EQUIPMENT_RENTAL = 307;
   */
  GRIP_EQUIPMENT_RENTAL = 307,

  /**
   * @generated from enum value: WORK_FUNCTION_LIGHTING_EQUIPMENT_RENTAL = 308;
   */
  LIGHTING_EQUIPMENT_RENTAL = 308,

  /**
   * @generated from enum value: WORK_FUNCTION_CAMERA_EQUIPMENT_RENTAL = 309;
   */
  CAMERA_EQUIPMENT_RENTAL = 309,

  /**
   * @generated from enum value: WORK_FUNCTION_CINEMA_EQUIPMENT_RENTAL = 310;
   */
  CINEMA_EQUIPMENT_RENTAL = 310,

  /**
   * @generated from enum value: WORK_FUNCTION_PHANTOM_OPERATOR = 311;
   */
  PHANTOM_OPERATOR = 311,

  /**
   * @generated from enum value: WORK_FUNCTION_FOOD_STYLIST = 312;
   */
  FOOD_STYLIST = 312,
}

/**
 * Describes the enum protos.general.WorkFunction.
 */
export const WorkFunctionSchema: GenEnum<WorkFunction> = /*@__PURE__*/
  enumDesc(file_general_work_function, 0);

